export const LABEL = 'Show correct answers after submission';
export const MESSAGE = "If the student's answer is wrong, having this enabled will show them the correct answer to that question they got wrong.";
